module.exports = __webpack_public_path__ + "media/cgae/bannerheader-9fbf0b8d.png";